import { render, staticRenderFns } from "./BrickOctagon.vue?vue&type=template&id=d969843c&scoped=true&"
import script from "./BrickOctagon.vue?vue&type=script&lang=js&"
export * from "./BrickOctagon.vue?vue&type=script&lang=js&"
import style0 from "./BrickOctagon.vue?vue&type=style&index=0&id=d969843c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d969843c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d969843c')) {
      api.createRecord('d969843c', component.options)
    } else {
      api.reload('d969843c', component.options)
    }
    module.hot.accept("./BrickOctagon.vue?vue&type=template&id=d969843c&scoped=true&", function () {
      api.rerender('d969843c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/BrickOctagon.vue"
export default component.exports